import styled from 'styled-components';
import { palette } from 'styled-tools';

import { OptionalBackgroundButton } from '@calm-web/design-system';

export const StyledButton = styled(OptionalBackgroundButton)`
	color: ${palette('white')};
	background: ${palette('gradientCalmBrand')};
	text-transform: capitalize;
`;
